export function pxToRem(px, base = 16) {
  if (typeof px !== 'number' || isNaN(px)) {
    throw new Error('px参数必须是有效数字');
  }
  if (typeof base !== 'number' || base <= 0) {
    throw new Error('base参数必须是大于0的数字');
  }
  return px / base + 'rem';
}
